"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableWrapperStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const types_1 = require("../types");
exports.TableWrapperStyled = styled_components_1.default.div `
  overflow: auto;
  height: ${({ bodyHeight }) => bodyHeight};
  & table {
    width: 100%;
    border-collapse: collapse;
    position: relative;
    & tr {
      box-sizing: border-box;
      vertical-align: ${({ rowVerticalAlign }) => rowVerticalAlign || types_1.TABLE_ROW_VERTICAL_ALIGN.top};
      border-bottom: ${({ theme }) => `solid 1px ${theme.colors.borders.grid}`};

      ${({ isLastRowBorderShown }) => !isLastRowBorderShown && `&:last-child {  border-bottom: 0; }`}

      & td {
        padding-left: ${({ theme }) => theme.spacing.s};
        padding-right: ${({ theme }) => theme.spacing.l};
      }
    }
  }
`;
exports.TableWrapperStyled.displayName = 'TableWrapperStyled';
//# sourceMappingURL=TableWrapperStyled.js.map